import { render, staticRenderFns } from "./WishListAction.vue?vue&type=template&id=e454dd74&"
import script from "./WishListAction.vue?vue&type=script&lang=js&"
export * from "./WishListAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports